export default __webpack_public_path__ + "static/media/post-04-detail.f832e576.jpg";